import React from 'react';

// Shared card surface (FECOA-2174): a white panel with a hairline border.
export const Card = ({ as: Component = 'div', className = '', children, ...props }) => (
  <Component className={`card ${className}`} {...props}>
    {children}
  </Component>
);

export const CardHeader = ({ title, description, icon: Icon, actions, className = '', children }) => (
  <div className={`card-header ${className}`}>
    <div className="flex min-w-0 items-center gap-3">
      {Icon && <Icon className="h-4 w-4 flex-shrink-0 text-gray-400 dark:text-gray-500" strokeWidth={1.75} aria-hidden="true" />}
      <div className="min-w-0">
        {title && <h2 className="card-title truncate">{title}</h2>}
        {description && <p className="card-description">{description}</p>}
        {children}
      </div>
    </div>
    {actions && <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export const CardBody = ({ className = '', children }) => <div className={`card-body ${className}`}>{children}</div>;

export default Card;
